// extracted by mini-css-extract-plugin
module.exports = {"Layout":"DrugInfo_Layout__3AJ6h","search-container":"DrugInfo_search-container__xdnnK","calculate-button":"DrugInfo_calculate-button__3WjBW"};